'use client';

import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';

export const htmlFrom = (str: string) => {
  const cleanHtmlString = DOMPurify.sanitize(str, {
    USE_PROFILES: { html: true },
  });

  return parse(cleanHtmlString, {});
};
